import { WindowLevelTool } from "@cornerstonejs/tools";
import React, { useContext, useEffect, useRef, useState } from "react";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import { setVOILUTRange } from "../../../helpers/WindowLevelUtility";
import themeContext from "../../../../../context/theme/ThemeContext";


const WindowLevelPresets = ({ wl, setShowDropDown }) => {
  const [hovered, setHovered] = useState(false);
  const { activeViewportIndex, activeTool, isMPRActive } = useContext(ViewportContext);
const [activePreset, setActivePreset] = useState("");
const { theme } = useContext(themeContext);

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleWindowLevelPresetClick = () => {
    setShowDropDown(false);
    setActivePreset(wl.key);
    setVOILUTRange(activeViewportIndex, wl.ww, wl.wc, wl.edge, isMPRActive);
  };

  useEffect(() => {
    if(activeTool !== WindowLevelTool.toolName) {
        setActivePreset("");
    }
  }, [activeTool])
  

  return (
    <div
    //   style={{ display: "flex", alignItems :"center", height: "40px", color: `${hovered ? "#0085FF" : "white"}` }}
      className={`stack-scroll-dropdown-elements ${
        hovered ? "hovered":""}`}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
      onClick={handleWindowLevelPresetClick}
    >
      {wl.key}
    </div>
  );
};

export default WindowLevelPresets;
